<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 哮天系统
                </el-breadcrumb-item>
				<el-breadcrumb-item>营销策略</el-breadcrumb-item>
				<el-breadcrumb-item>服务配置</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-input v-model="query.name" placeholder="名称" class="handle-input mr10"></el-input>
				<el-select v-model="query.platformType" placeholder="请选择服务类型">
					<el-option key="" label="请选择服务类型" value=""></el-option>
					<el-option v-for="item in platformTypeKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>
				&nbsp;
				<el-select v-model="query.supportBatch" placeholder="请选择是否支持批量推送">
					<el-option key="" label="请选择是否支持批量推送" value=""></el-option>
					<el-option key=0 label="不支持" :value=0></el-option>
					<el-option key=1 label="支持" :value=1></el-option>
				</el-select>
				&nbsp;
				<el-select v-model="query.status" placeholder="请选择状态">
					<el-option key="" label="请选择状态" value=""></el-option>
					<el-option key=0 label="启用" :value=0></el-option>
					<el-option key=1 label="禁用" :value=1></el-option>
				</el-select>
				&nbsp;
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
				:cell-style="{padding:4+'px'}"
				stripe
            >
                <el-table-column type="selection" width="55" align="center"></el-table-column>
				<el-table-column prop="name" label="服务名称"></el-table-column>
				<el-table-column prop="platformType" label="服务类型" :formatter = "platformTypeFormat"></el-table-column>
				<el-table-column prop="domain" label="服务器/域名">
					<template slot-scope="scope">
                        {{(scope.row.smtp && scope.row.domain)?(scope.row.smtp + "/" +scope.row.domain):(scope.row.smtp?scope.row.smtp:scope.row.domain)}}
                    </template>
				</el-table-column>
				<el-table-column prop="limits" label="单日限制"></el-table-column>
				<el-table-column prop="supportBatch" label="支持批量推送">
					<template slot-scope="scope">
                        {{scope.row.supportBatch?"是":"否"}}
                    </template>
				</el-table-column>
				<el-table-column prop="status" label="状态" :formatter = "statusFormat"></el-table-column>
				<el-table-column prop="createTime" label="创建时间" width = "160px"></el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.$index, scope.row)"
							v-if="controll['edit']"
                        >编辑</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="handleDelete(scope.$index, scope.row)"
							v-if="controll['delete']"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
			<div class="record-a-d">
				<el-button
                    type="warning"
                    icon="el-icon-delete"
                    class="handle-del mr10"
                    @click="delAllSelection"
					v-if="controll['delete-batch']"
                >批量删除</el-button>
				<el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
                    @click="handleAdd"
					v-if="controll['add']"
                >添加记录</el-button>
			</div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false :title="title" :visible.sync="editVisible" width="55%">
            <el-form ref="form" :model="form" label-width="120px" :rules="rules">
				<el-row>
					<el-col :span="14">
						<el-form-item label="名称" prop="name">
							<el-input v-model="form.name"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="10">
						<el-form-item label="服务类型" prop="platformType">
							<el-select v-model="form.platformType" placeholder="请选择服务类型">
								<el-option key="" label="请选择服务类型" value=""></el-option>
								<el-option v-for="item in platformTypeKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="14">
						<el-form-item label="SMTP服务器" prop="smtp" v-if="form.platformType <= 9">
							<el-input v-model="form.smtp"></el-input>
						</el-form-item>
						<el-form-item label="域名" prop="domain" v-if="form.platformType >= 10">
							<el-input v-model="form.domain"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="10">
						<el-checkbox v-model="form.supportBatch" style="margin-top:10px;margin-left:50px;" v-if="form.platformType >= 10">批量推送</el-checkbox>
						<el-checkbox v-model="form.supportStatusConfirm" style="margin-top:10px;margin-left:50px;" v-if="form.platformType < 10">状态查询</el-checkbox>
					</el-col>
				</el-row>
				<el-form-item label="邮箱账号" prop="accountName" v-if="form.platformType <= 9">
					<el-input v-model="form.accountName"></el-input>
				</el-form-item>
				<el-form-item label="邮箱密码" prop="password" v-if="form.platformType <= 9">
					<el-input type="password" v-model="form.password"></el-input>
				</el-form-item>
				<el-form-item label="域名" prop="domain" v-if="form.supportStatusConfirm && form.platformType < 10">
					<el-input v-model="form.domain"></el-input>
				</el-form-item>
				<el-form-item label="账号" prop="accountName" v-if="form.platformType >= 10">
					<el-input v-model="form.accountName"></el-input>
				</el-form-item>
				<el-form-item label="接入ID" prop="accessKey" v-if="form.platformType >= 10 || form.supportStatusConfirm">
					<el-input v-model="form.accessKey"></el-input>
				</el-form-item>
				<el-form-item label="接入秘钥" prop="accessSecret" v-if="form.platformType >= 10 || form.supportStatusConfirm">
					<el-input v-model="form.accessSecret"></el-input>
				</el-form-item>
				<el-row>
					<el-col :span="14">
						<el-form-item label="发件人" prop="mailFrom">
							<el-input v-model="form.mailFrom"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="10">
						<el-form-item label="发件人昵称" prop="mailFromAlias">
							<el-input v-model="form.mailFromAlias"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="14">
						<el-form-item label="单日限制" prop="limits">
							<el-input v-model="form.limits"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="10">
						<el-form-item label="状态" prop="status">
							<el-select v-model="form.status" placeholder="请选择状态">
								<el-option key="" label="请选择状态" value=""></el-option>
								<el-option key=0 label="启用" :value=0></el-option>
								<el-option key=1 label="停用" :value=1></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-form-item label="动态盐值" prop="solt">
					<el-input v-model="form.solt"></el-input>
				</el-form-item>
				<el-form-item label="测试邮箱" prop="mailTestTo">
					<el-input type=textarea :rows=2 v-model="form.mailTestTo" placeholder="多个地址用','分割, 最多支持5个"></el-input>
				</el-form-item>
					
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { fetchMarketingMailConfigData, saveMarketingMailConfig, deleteMarketingMailConfig, getMarketingMailConfig, getSupportEmailKV} from '../../../api/index';
export default {
    name: 'market-mail-config',
    data() {		
        return {
            query: {
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1,
			title:"",
			rules: {
                name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
				platformType: [{ required: true, message: '请选择服务类型', trigger: 'blur' }],
				domain: [{ required: true,  message: '请输入服务器', trigger: 'blur' }],
				accountName: [{ required: true, message: '请输入账号/邮箱账号', trigger: 'blur' }],
				accessKey: [{ required: true, message: '请输入接入ID', trigger: 'blur' }],
				accessSecret: [{ required: true, message: '请输入邮箱密码/接入秘钥', trigger: 'blur' }],
				mailFrom: [{ required: true, message: '请输入发件人邮箱', trigger: 'blur' }],
				mailFromAlias: [{ required: true, message: '请输入发件人昵称', trigger: 'blur' }],
				supportBatch: [{ required: true, message: '请选择是否支持批量推送', trigger: 'blur' }],
				limits: [{ required: true, message: '请输入单日限制', trigger: 'blur' }],
				status: [{ required: true, message: '请选择状态', trigger: 'blur' }],
				mailTestTo: [{ required: true, message: '请输入测试邮箱', trigger: 'blur' }],
            },
			count:0,
			platformTypeKV:[],
			controll:{}
        };
    },
    created() {
		this.controll = getControll("market-mail-config");
        this.getData();
		this.getSupportEmail();
    },
    methods: {
		validateEmail(mail) {
			const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // 邮箱格式的正则表达式
			return regex.test(mail); // 判断邮箱是否符合要求并更新isEmailValid状态
		},
		//获取支持的邮件服务
		getSupportEmail() {
			getSupportEmailKV().then(res => {
				if (res.code == 0 ) {
					this.platformTypeKV = res.data;
				} else {
					this.$message.error("获取邮件支持失败！" + res.message);
				}
			});
		},
		//状态格式化
		statusFormat(row, column, cellValue) {
			if (cellValue == 0) {
				return '启用';
			} else {
				return '禁用';
			}
		},
		platformTypeFormat(row, column, cellValue) {
			let index = this.platformTypeKV.findIndex(item => {
				if (item.key === cellValue) {
					return true;
				}
			});
			if (index === -1) return cellValue;
			return this.platformTypeKV[index].value;
		},
        // 获取数据
        getData() {
            fetchMarketingMailConfigData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteMarketingMailConfig([row.id]).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        delAllSelection() {
            const length = this.multipleSelection.length;
			if (length == 0) {
				this.$message.error(`请选择要删除的记录！`);
				return;
			}
            let ids = [];
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
				ids.push(this.multipleSelection[i].id)
            }
			this.$confirm('确定要删除选中的记录吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteMarketingMailConfig(ids).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
				})
				.catch(() => {});
        },
		//添加操作
		handleAdd() {
			this.form = {};
			this.$set(this.form, 'supportBatch', "false");
			this.$set(this.form, 'supportStatusConfirm', "false");
			this.title = "添加新纪录";
			this.editVisible = true;
		},
        // 编辑操作
        handleEdit(index, row) {
			this.title = "编辑";
			getMarketingMailConfig(row.id).then(res => {
				if (res.code == 0) {
					this.form = res.data;
					if (this.form['supportBatch'] == undefined) {
						this.$set(this.form, 'supportBatch', "false");
					}
					this.$set(this.form, 'supportStatusConfirm', (this.form["smtp"] != "" && this.form["accessKey"] != "" && this.form["accessSecret"] != ""));
					this.editVisible = true;
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
        },
        // 保存编辑
        saveEdit() {
			if (!this.validateEmail(this.form["mailFrom"])) {
				this.$message.error(`请输入正确的发件人！`);
			}
			let testTos = this.form["mailTestTo"].split(",");
			if (testTos.length > 5) {
				this.$message.error(`测试邮箱最多只能支持5个！`);
				return;
			}
			for (var i = 0; i < testTos.length; i++) {
				if (!this.validateEmail(testTos[i])) {
					this.$message.error(`请输入正确的测试邮箱！`);
					return;
				}
			}
			this.$refs.form.validate(valid => {
				if (valid) {
					saveMarketingMailConfig(this.form).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.editVisible = false;
							this.getData();
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 180px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
